import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ChangeEvent,
  Fragment,
  useContext,
  useEffect,
  // useEffect,
  useMemo,
  useState,
} from "react";
import { RemittanceContext, RemittanceContextType } from "..";
// import FilterButton from "./FilterButton";
import { ArrowDownward } from "@mui/icons-material";
import { useMutation } from "react-query";
import {
  downloadRemitance,
  getRemittanceActivityDetails,
  searchRemittanceWithDate,
} from "../services";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { DownloadRemittanceType, SearchRemittanceParams } from "../types";
import usePopup from "../../../hooks/usePopup";
import { useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { FormOnChangeEventType } from "../../../EMR/types";
import dayjs from "dayjs";
import DetailsComponent from "./DetailsComponent";
import moment from "moment";
// import useAuthentication from "@hooks/useAuthentication";
type SearchParamType = Omit<SearchRemittanceParams, "clinicId">;
const selectorKey = "id";
function RemittanceList() {
  const theme = useTheme();
  const { control, reset } = useForm();
  const { showSnackbar } = usePopup();
  const [selected, setSelected] = useState(-1);
  const [checkedItems, setCheckedItems] = useState<any>({});
  const [tableData, setTableData] = useState<DownloadRemittanceType[]>([]);
  const [searchParams, setSearchParams] = useState<SearchParamType>({
    fromDate: moment().format("yyyy-MM-DD"),
    toDate: moment().format("yyyy-MM-DD"),
  });
  const { mutate: getRemitanceData, isLoading: remittanceLoading } =
    useMutation(downloadRemitance, {
      onSuccess: (data) => {
        const items = data.response?.items || [];
        const messageFromBackend = data.response?.responseMessage || "";

        if (data.responseIndicator === "success") {
          if (items.length > 0) {
            setTableData(items);
          } else {
            setTableData([]);
            showSnackbar({
              message: messageFromBackend,
              open: true,
              variant: "info",
              duration: 2000,
            });
          }
        } else {
          showSnackbar({
            message: data.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong!",
          open: true,
          variant: "warning",
          duration: 7000,
        });
      },
    });
  const { setFilter, filter } = useContext(
    RemittanceContext,
  ) as RemittanceContextType;

  const {
    mutate: getActivity,
    data: activityData,
    isLoading: activityDataLoading,
  } = useMutation(getRemittanceActivityDetails);

  const { mutate: searchRemittance, isLoading: remittanceSearchLoading } =
    useMutation(searchRemittanceWithDate, {
      onSuccess: (result) => {
        const items = result.response?.items || [];
        const messageFromBackend = result.response?.responseMessage || "";

        if (result.responseIndicator === "success") {
          if (items.length > 0) {
            setTableData(items);
          } else {
            // ✅ Success but no items → show backend message
            setTableData([]);
            showSnackbar({
              message: messageFromBackend,
              open: true,
              variant: "info",
              duration: 2000,
            });
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            open: true,
            variant: "warning",
            duration: 2000,
          });
        }
      },
    });

  const handleOpen = (e: any) => {
    const id: string = e.currentTarget.getAttribute("data-mrn") || "";
    const index = parseInt(e.currentTarget.getAttribute("data-index") || "-1");
    if (id && index != selected) {
      getActivity(id);
    }
    if (index == selected) {
      setSelected(-1);
    } else {
      setSelected(index);
    }
  };

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => {
    console.log(page);

    setFilter((prev: any) => ({
      ...prev,
      page,
      type: "pagination",
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFilter((prev: any) => ({
      ...prev,
      rowsPerPage: parseInt(event.target.value, 25),
      page: 0,
      type: "pagination",
    }));
  };

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      let allItems = {};
      tableData.forEach((item: any) => {
        allItems = {
          ...allItems,
          [item.emrno]: true,
        };
      });
      setCheckedItems(allItems);
    } else {
      setCheckedItems({});
    }
  };

  const selectedItemsCount = useMemo(() => {
    return Object.keys(checkedItems).length;
  }, [checkedItems]);

  const download = () => {
    const today = moment().format("YYYY-MM-DD");
    const params = {
      fromDate: today,
      toDate: today,
    };
    setSearchParams(params);
    reset(params);
    getRemitanceData();
  };

  const remittanceList = useMemo(() => {
    if (tableData?.length) {
      return tableData.slice(
        filter.rowsPerPage * filter.page,
        filter.rowsPerPage * filter.page + filter.rowsPerPage,
      );
    }
    return [];
  }, [tableData, filter.rowsPerPage, filter.page]);

  const onChange = (e: FormOnChangeEventType) => {
    const { target } = e;
    const params = {
      ...searchParams,
      [target.name]: target.value,
    } as SearchParamType;
    setSearchParams(params);
    if (params.fromDate != "" && params.toDate != "") {
      searchRemittance(params);
    }
  };

  useEffect(() => {
    const savedParams = localStorage.getItem("remittanceParams");
    const initParams = {
      fromDate: savedParams
        ? JSON.parse(savedParams).fromDate
        : moment().format("yyyy-MM-DD"),
      toDate: savedParams
        ? JSON.parse(savedParams).toDate
        : moment().format("yyyy-MM-DD"),
    };
    setSearchParams(initParams);
    searchRemittance(initParams);
    reset(initParams);
  }, []);

  // const{user}= useAuthentication();
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates Id";
  const idHeading = "Civil ID"

const headings = [
  // "checkbox",
  "Sl.no",
  idHeading,
  "Name",
  // "Encounter date",
  "Insurance Type",
  "Receiver",
  "Payer",
  "Insurance amount",
  // "Remittance amount",
  "Received amount",
];

  return (
    <TableContainer className="flex flex-col h-fit">
      {/* <TextField onChange={(e)=>{}}/> */}

      <div className="flex flex-row gap-2 items-center justify-between p-3 border-b">
        <Typography>
          <strong>Remittance</strong>
        </Typography>

        <div className="flex gap-2 items-center">
          <form className="flex flex-row items-center gap-2">
            <div className="col-span-3">
              <CustomFormField
                control={control}
                element="datepicker"
                fieldProps={{
                  label: "From date",
                  disabled: remittanceSearchLoading,
                }}
                calenderProps={{ maxDate: dayjs() }}
                name="fromDate"
                rules={{ required: "From date required", onChange }}
              />
            </div>
            <div className="col-span-4">
              <CustomFormField
                control={control}
                element="datepicker"
                fieldProps={{
                  label: "To date",
                  disabled: remittanceSearchLoading,
                }}
                name="toDate"
                rules={{ required: "From date required", onChange }}
              />
            </div>
            {remittanceSearchLoading && <CircularProgress size={20} />}
          </form>
          <Button
            onClick={download}
            color="success"
            disabled={remittanceLoading || remittanceSearchLoading}
            endIcon={
              remittanceLoading ? (
                <CircularProgress size={18} color="success" />
              ) : (
                <ArrowDownward />
              )
            }
          >
            Download Remittance
          </Button>
        </div>
      </div>

      <div className="max-h-[70dvh] h-[70dvh] overflow-y-auto relative">
        <Table
          size="small"
          aria-label="a dense table"
          className={tableData?.length ? "w-full" : "w-full h-full"}
        >
          <TableHead
            className="sticky top-0"
            sx={{
              backgroundColor: theme.palette.background.paper,
              opacity: 1,
              zIndex: 10,
            }}
          >
            <TableRow>
              {headings?.map((title, index) => (
                <TableCell key={index} sx={{ fontWeight: "bold" }}>
                  {title == "checkbox" ? (
                    <Checkbox
                      checked={selectedItemsCount == filter.rowsPerPage}
                      sx={{
                        padding: "0px",
                        backgroundColor: theme.palette.background.paper,
                        opacity: 1,
                      }}
                      color="default"
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No records"}
            dataLoading={false}
            isData={tableData.length > 0}
            totalSpan={{ col: headings.length, row: 5 }}
          >
            {remittanceList?.map(
              (item: DownloadRemittanceType, index: number) => (
                <Fragment key={`${index}tablekey`}>
                  <TableRow
                    hover
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      backgroundColor:
                        index % 2 == 0 ? theme.palette.grey[100] : "",
                    }}
                  >
                    {/* <TableCell>
                    <Checkbox
                      sx={{ padding: "0px" }}
                      onClick={() => {
                        handleSelectOne(item.emrno);
                      }}
                      checked={checkedItems[item.emrno] ? true : false}
                    />
                  </TableCell> */}
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey] || 0}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {filter.page * filter.rowsPerPage + (index + 1)}
                    </TableCell>
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey] || 0}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.emiratesId}
                    </TableCell>
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.patientName}
                    </TableCell>
                    {/* <TableCell
                    className="cursor-pointer"
                    onClick={() => {
                      handleOpen(index);
                    }}
                  >
                    {item.encounterDate}
                  </TableCell> */}
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.insuranceType}
                    </TableCell>
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item.receiver}
                    </TableCell>
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.payer}
                    </TableCell>
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.insuranceAmount?.toFixed(2)}
                    </TableCell>
                    {/* <TableCell
                    className="cursor-pointer"
                    data-mrn={item?.mrn}
                    data-index={index}
                    onClick={handleOpen}
                  >
                    {item?.remittanceAmount}
                  </TableCell> */}
                    <TableCell
                      className="cursor-pointer"
                      data-mrn={item[selectorKey]}
                      data-index={index}
                      onClick={handleOpen}
                    >
                      {item?.receivedAmount?.toFixed(2)}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        backgroundColor:
                          index % 2 == 0 ? theme.palette.grey[100] : "",
                      }}
                      colSpan={headings.length + 1}
                    >
                      <Collapse
                        in={index == selected}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Box sx={{ margin: 1 }}>
                          {activityDataLoading ? (
                            <div className="flex justify-center w-full gap-3">
                              Loading <CircularProgress size={15} />{" "}
                            </div>
                          ) : (
                            <div>
                              <IconButton></IconButton>
                              <DetailsComponent
                                data={activityData?.response || []}
                                encounterId={item.encounterId}
                              />
                            </div>
                          )}
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </Fragment>
              ),
            )}
          </CustomTableBody>
        </Table>
      </div>
      <div className="flex justify-end">
        <TablePagination
          sx={{ border: 0 }}
          rowsPerPageOptions={[5, 10, 25]}
          colSpan={3}
          count={tableData?.length || 0}
          rowsPerPage={filter.rowsPerPage}
          page={filter.page}
          slotProps={{
            select: {
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            },
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </TableContainer>
  );
}

export default RemittanceList;



// const createSampleData = () => {
//   let sampleData: any[] = [];
//   for (let i = 0; i < 20; i++) {
//     sampleData = [
//       ...sampleData,
//       {
//         claimId: `test${i}`,
//         mrn: `test${i}`,
//         doctor: `test${i}`,
//         postOffice: `test${i}`,
//         insName: `test${i}`,
//         insType: `test${i}`,
//         encounterDate: `test${i}`,
//         name: `test${i}`,
//         status: `test${i}`,
//         emrno: `test${i}`,
//       },
//     ];
//   }
//   return sampleData;
// };
